import { SCANNER_RESOLUTION_WIDTH } from 'src/constants/responsiveProps';

// The unload pages fit small screens exactly, so there zoom is held at its initial scale of 1; wider screens keep it
// for accessibility
const ZOOM_LOCK_SUFFIX = ', maximum-scale=1, minimum-scale=1, user-scalable=no';

// Locks zoom on small screens while the page that calls it is shown; the function it returns puts the viewport back as
// it was
export const lockZoomOnSmallScreens = () => {
    const viewport = document.querySelector('meta[name="viewport"]');
    const own = viewport?.getAttribute('content') ?? '';
    const applyZoomLock = () => viewport?.setAttribute('content',
        own + (document.documentElement.clientWidth <= SCANNER_RESOLUTION_WIDTH ? ZOOM_LOCK_SUFFIX : ''));
    applyZoomLock();
    window.addEventListener('resize', applyZoomLock);
    window.addEventListener('orientationchange', applyZoomLock);
    return () => {
        window.removeEventListener('resize', applyZoomLock);
        window.removeEventListener('orientationchange', applyZoomLock);
        viewport?.setAttribute('content', own);
    };
};
